export default __webpack_public_path__ + "static/media/room-polen-2.34099a74.jpg";